import React from 'react';
import image from './img/logo.png';

const Logo = () => (
  <img src={image} alt="Logo" height={ 40 }/>
);

export default Logo;